if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) return;

      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      
      // 用于取消进行中的请求
      this.currentController = null;
      
      // 节流标志
      this.isSubmitting = false;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      // 防止重复提交
      if (this.isSubmitting) return;
      
      const submitButton = this.querySelector('[type="submit"]');
      if (!submitButton) return;
      
      if (submitButton.classList.contains('loading')) return;

      // 获取加载动画元素（添加存在性检查）
      const spinner = this.querySelector('.loading-overlay__spinner');
      
      // 清除之前的错误消息
      this.handleErrorMessage();
      
      // 保存当前活动元素以便恢复焦点
      if (this.cartNotification && this.cartNotification.setActiveElement) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      // 设置加载状态
      this.isSubmitting = true;
      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');

      // 取消之前的请求
      if (this.currentController) {
        this.currentController.abort();
      }
      this.currentController = new AbortController();

      // 获取配置
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.signal = this.currentController.signal;
      delete config.headers['Content-Type'];

      // 构建 FormData
      const formData = new FormData(this.form);
      
      // 获取需要渲染的区块（添加存在性检查）
      if (this.cartNotification && typeof this.cartNotification.getSectionsToRender === 'function') {
        const sectionsToRender = this.cartNotification.getSectionsToRender();
        if (sectionsToRender && sectionsToRender.length) {
          formData.append('sections', sectionsToRender.map((section) => section.id));
        }
      }
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      // 确保 routes 对象存在
      const cartAddUrl = (typeof routes !== 'undefined' && routes.cart_add_url) 
        ? routes.cart_add_url 
        : '/cart/add';

      fetch(cartAddUrl, config)
        .then((response) => {
          if (!response.ok) {
            return response.json().then(err => Promise.reject(err));
          }
          return response.json();
        })
        .then((response) => {
          // 处理错误状态
          if (response.status) {
            this.handleErrorMessage(response.description);
            // 显示快速查看成功消息（如果存在）
            this.showQuickviewMessage(false);
            return;
          }

          // 成功添加到购物车
          if (this.cartNotification && typeof this.cartNotification.renderContents === 'function') {
            this.cartNotification.renderContents(response);
          }
          this.showQuickviewMessage(true);
          
          // 触发自定义事件，供其他模块监听
          this.dispatchEvent(new CustomEvent('product-form:added', { 
            detail: { response, variantId: this.getVariantId() },
            bubbles: true 
          }));
        })
        .catch((e) => {
          // 忽略取消请求的错误
          if (e.name === 'AbortError') return;
          
          console.error('Add to cart error:', e);
          this.handleErrorMessage(e.description || e.message || 'An error occurred. Please try again.');
          this.showQuickviewMessage(false);
        })
        .finally(() => {
          // 重置状态
          this.isSubmitting = false;
          this.currentController = null;
          
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    // 获取当前选中的变体ID
    getVariantId() {
      const idInput = this.form.querySelector('[name=id]');
      return idInput ? idInput.value : null;
    }

    // 显示/隐藏快速查看弹窗的成功消息
    showQuickviewMessage(success) {
      const quickviewMessage = this.querySelector('.wbquicksuccess');
      if (!quickviewMessage) return;
      
      if (success) {
        quickviewMessage.classList.remove('hidden');
        // 可选：3秒后自动隐藏
        setTimeout(() => {
          if (quickviewMessage && !quickviewMessage.classList.contains('hidden')) {
            quickviewMessage.classList.add('hidden');
          }
        }, 3000);
      } else {
        quickviewMessage.classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      // 懒加载错误消息元素
      if (!this.errorMessageWrapper) {
        this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper');
      }
      if (!this.errorMessage && this.errorMessageWrapper) {
        this.errorMessage = this.errorMessageWrapper.querySelector('.product-form__error-message');
      }

      // 如果元素不存在，静默返回
      if (!this.errorMessageWrapper) return;

      if (!errorMessage) {
        this.errorMessageWrapper.setAttribute('hidden', true);
        if (this.errorMessage) this.errorMessage.textContent = '';
      } else {
        this.errorMessageWrapper.removeAttribute('hidden');
        if (this.errorMessage) this.errorMessage.textContent = errorMessage;
        
        // 可选：滚动到错误消息位置
        this.errorMessageWrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    // 可选：添加重置表单的方法（用于变体切换时清除错误）
    resetForm() {
      this.handleErrorMessage(false);
      this.isSubmitting = false;
      
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      }
      
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.add('hidden');
    }
  });
}

// 确保 fetchConfig 函数存在（如果不存在则定义）
if (typeof fetchConfig === 'undefined') {
  window.fetchConfig = function(type = 'json') {
    return {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json', 
        'Accept': `application/${type}` 
      }
    };
  };
}

// 确保 routes 对象存在（如果主题没有定义，则提供默认值）
if (typeof routes === 'undefined') {
  window.routes = {
    cart_add_url: '/cart/add',
    cart_url: '/cart',
    cart_change_url: '/cart/change',
    cart_update_url: '/cart/update'
  };
}